import { createSlice } from "@reduxjs/toolkit";
import question31 from "../../../assets/imgs/question31.jpg";
import question32 from "../../../assets/imgs/question32.jpg";
import ques3335 from "../../../assets/imgs/ques3335.jpg";
import ques36 from "../../../assets/imgs/ques36.jpg";

export const examsSlice = createSlice({
  name: "exams",
  initialState: {
    list: [],
    orderArray: [],
  },
  reducers: {
    setExams: (state, action) => {
      state.list = action.payload;
    },
    setOrderArray: (state, action) => {
      state.orderArray = action.payload;
    },
  },
});

export const { setExams, setOrderArray } = examsSlice.actions;

export default examsSlice.reducer;

export const fetchOrderArray = () => (dispatch) => {
  function getRandomNumber() {
    if (getRandomNumber.remaining.length === 0) {
      getRandomNumber.remaining = Array.from(Array(40).keys()).sort(
        () => Math.random() - 0.5
      );
    }
    return getRandomNumber.remaining.pop();
  }
  getRandomNumber.remaining = [];
  let orderArray = [];
  for (let i = 0; i < 25; i++) {
    orderArray.push(parseInt(getRandomNumber()));
  }
  dispatch(setOrderArray(orderArray));
};

export const fetchAllExams = () => (dispatch) => {
  const exams = [
    // 1
    {
      Question: "What is the vertex of the function f(x) = x^2 - 4x + 3?",
      Img: "",
      Responses: ["(2, -1)", "(-2, 3)", "(4, 3)", "(0, 3)"],
      Correct: [0],
      Verse: "",
      List: "",
    },

    // 2
    {
      Question: "The graph of f(x) = -2x^2 + 5x - 1 opens:",
      Img: "",
      Responses: ["Upward", "Downward", "To the right", "To the left"],
      Correct: [1],
      Verse: "",
      List: "",
    },

    // 3
    {
      Question: "What is the y-intercept of f(x) = 3x^2 - 2x + 4?",
      Img: "",
      Responses: ["3", "-2", "4", "5"],
      Correct: [2],
      Verse: "",
      List: "",
    },

    // 4
    {
      Question: "Which are the zeros of f(x) = x^2 - 9?",
      Img: "",
      Responses: [
        "x = 9 and x = -1",
        "x = -9 and x = 1",
        "x = 3 and x = -3",
        "x = 0",
      ],
      Correct: [2],
      Verse: "",
      List: "",
    },

    // 5
    {
      Question: "What is the axis of symmetry of f(x) = 2x^2 + 8x + 1?",
      Img: "",
      Responses: ["x = -2", "x = 2", "x = -4", "x = 4"],
      Correct: [0],
      Verse: "",
      List: "",
    },

    // 6
    {
      Question: "The function f(x) = x^2 - 6x + 5 has:",
      Img: "",
      Responses: [
        "A maximum value",
        "A minimum value",
        "No maximum or minimum",
        "Both a maximum and a minimum",
      ],
      Correct: [1],
      Verse: "",
      List: "",
    },

    // 7
    {
      Question: "Find f(2) if f(x) = 2x^2 - x + 1.",
      Img: "",
      Responses: ["5", "7", "9", "11"],
      Correct: [1],
      Verse: "",
      List: "",
    },

    // 8
    {
      Question:
        "Which formula represents the time when an object hits the ground for h(t) = -4.9t^2 + 15t + 5?",
      Img: "",
      Responses: [
        "Calculate its derivative",
        "Set t = 0 and solve for h",
        "Set h(t) = 0 and solve for t",
        "Find the vertex of the equation",
      ],
      Correct: [2],
      Verse: "",
      List: "",
    },

    // 9
    {
      Question: "How many real solutions does x^2 + 4x + 5 = 0 have?",
      Img: "",
      Responses: ["0", "1", "2", "Infinitely many"],
      Correct: [0],
      Verse: "",
      List: "",
    },

    // 10
    {
      Question: "What is the vertex form of y = x^2 + 6x + 5?",
      Img: "",
      Responses: [
        "y = (x + 3)^2 + 5",
        "y = (x - 3)^2 - 4",
        "y = (x + 3)^2 - 4",
        "y = (x - 3)^2 + 4",
      ],
      Correct: [2],
      Verse: "",
      List: "",
    },

    // 11
    {
      Question:
        "In the quadratic x^2 + 4x + 4 = 0, what is the role of the discriminant?",
      Img: "",
      Responses: [
        "Determines the number and type of roots",
        "Determines the maximum value of the function",
        "Finds the axis of symmetry",
        "Calculates the derivative",
      ],
      Correct: [0],
      Verse: "",
      List: "",
    },

    // 12
    {
      Question: "What is the standard form of a quadratic function?",
      Img: "",
      Responses: [
        "y = ax^2 + bx + c",
        "y = a(x - h)^2 + k",
        "y = ax + b",
        "y = a/x + b/x",
      ],
      Correct: [0],
      Verse: "",
      List: "",
    },

    // 13
    {
      Question:
        "What is the axis of symmetry in a quadratic equation ax^2 + bx + c?",
      Img: "",
      Responses: ["x = ab", "x = -b / 2a", "x = b / a", "x = -c / a"],
      Correct: [1],
      Verse: "",
      List: "",
    },

    // 14
    {
      Question: "How do you find the maximum height reached by a projectile?",
      Img: "",
      Responses: [
        "Find the y-intercept of the function",
        "Find the vertex of the quadratic equation",
        "Find the x-intercepts of the function",
        "Calculate the total time of flight",
      ],
      Correct: [1],
      Verse: "",
      List: "",
    },

    // 15
    {
      Question:
        "For a quadratic h(t) = -4.9t^2 + 9.8t + 20, what is the initial height?",
      Img: "",
      Responses: ["0 meters", "9.8 meters", "20 meters", "4.9 meters"],
      Correct: [2],
      Verse: "",
      List: "",
    },

    // 16
    {
      Question:
        "How do you determine if a quadratic opens upwards or downwards?",
      Img: "",
      Responses: [
        "By the sign of the coefficient of the x^2 term",
        "By the sign of the constant term",
        "By the discriminant",
        "By the sign of the linear term",
      ],
      Correct: [0],
      Verse: "",
      List: "",
    },

    // 17
    {
      Question: "What is the vertex of a quadratic function?",
      Img: "",
      Responses: [
        "Where the curve reaches a zero-axis crossing",
        "The highest or lowest point on the curve",
        "The point where the curve crosses the x-axis",
        "The point where the curve flattens",
      ],
      Correct: [1],
      Verse: "",
      List: "",
    },

    // 18
    {
      Question:
        "Which part of a projectile's motion does a quadratic function often model?",
      Img: "",
      Responses: [
        "Circular motion path",
        "Acceleration in a straight line",
        "Distance over time at constant speed",
        "Path of an object under gravity",
      ],
      Correct: [3],
      Verse: "",
      List: "",
    },

    // 19
    {
      Question: "Solve: x^2 - 7x + 12 = 0",
      Img: "",
      Responses: [
        "x = -2, -6",
        "x = -3, -4",
        "x = 2, 6",
        "x = 3, 4",
      ],
      Correct: [3],
      Verse: "",
      List: "",
    },

    // 20
    {
      Question: "Find the axis of symmetry of y = x^2 - 6x + 5.",
      Img: "",
      Responses: ["x = 6", "x = 3", "x = -3", "x = -6"],
      Correct: [1],
      Verse: "",
      List: "",
    },

    // 21
    {
      Question: "Find the vertex of y = x^2 - 4x + 1.",
      Img: "",
      Responses: ["(2, -3)", "(-2, -3)", "(2, 3)", "(-2, 3)"],
      Correct: [0],
      Verse: "",
      List: "",
    },

    // 22
    {
      Question: "Convert to vertex form: y = x^2 + 8x + 5",
      Img: "",
      Responses: [
        "y = (x - 4)^2 + 11",
        "y = (x - 4)^2 - 11",
        "y = (x + 4)^2 + 11",
        "y = (x + 4)^2 - 11",
      ],
      Correct: [3],
      Verse: "",
      List: "",
    },

    // 23
    {
      Question: "The discriminant of 2x^2 + 4x + 1 = 0 is:",
      Img: "",
      Responses: ["-4", "8", "4", "0"],
      Correct: [2],
      Verse: "",
      List: "",
    },

    // 24
    {
      Question: "How many real solutions does x^2 - 2x + 5 = 0 have?",
      Img: "",
      Responses: [
        "2 real solutions",
        "1 real solution",
        "No real solutions",
        "Infinite solutions",
      ],
      Correct: [2],
      Verse: "",
      List: "",
    },

    // 25
    {
      Question: "Find the vertex of y = (x - 3)^2 + 7.",
      Img: "",
      Responses: ["(3, 7)", "(-3, 7)", "(3, -7)", "(-3, -7)"],
      Correct: [0],
      Verse: "",
      List: "",
    },

    // 26
    {
      Question: "The axis of symmetry of y = -2x^2 + 4x - 1 is:",
      Img: "",
      Responses: ["x = 2", "x = -1", "x = 1", "x = -2"],
      Correct: [2],
      Verse: "",
      List: "",
    },

    // 27
    {
      Question: "Expand to standard form: y = (x - 5)^2 + 2",
      Img: "",
      Responses: [
        "y = x^2 - 10x + 27",
        "y = x^2 - 10x + 23",
        "y = x^2 + 10x + 27",
        "y = x^2 - 10x + 27",
      ],
      Correct: [3],
      Verse: "",
      List: "",
    },

    // 28
    {
      Question:
        "Find the maximum or minimum value of y = -x^2 + 4x + 1.",
      Img: "",
      Responses: [
        "Maximum = -5",
        "Maximum = 5",
        "Minimum = 5",
        "Minimum = -5",
      ],
      Correct: [1],
      Verse: "",
      List: "",
    },

    // 29
    {
      Question:
        "A ball is dropped from a 45 m building. Using the equation h = -16t^2 + s, how long until it reaches the ground?",
      Img: "",
      Responses: ["3 seconds", "1 second", "2 seconds", "1.5 seconds"],
      Correct: [3],
      Verse: "",
      List: "",
    },

    // 30
    {
      Question:
        "A projectile is launched upward at 20 m/s from a height of 25 m. When will it hit the ground? (Use g = 10 m/s^2.)",
      Img: "",
      Responses: ["3 seconds", "1 second", "5 seconds", "4 seconds"],
      Correct: [2],
      Verse: "",
      List: "",
    },

    // 31
    {
      Question:
        "What is the equation of the graph with vertex (2, -4) and x-intercepts (0, 0) and (4, 0)?",
      Img: question31,
      Responses: [
        "y = (x + 2)^2 + 4",
        "y = (x - 2)^2 + 4",
        "y = (x + 2)^2 - 4",
        "y = (x - 2)^2 - 4",
      ],
      Correct: [3],
      Verse: "",
      List: "",
    },

    // 32
    {
      Question:
        "What is the equation of the graph with vertex (-5, 4) and x-intercepts (-7, 0) and (-3, 0)?",
      Img: question32,
      Responses: [
        "y = -(x + 4)^2 + 5",
        "y = -(x + 5)^2 + 4",
        "y = -(x - 5)^2 - 4",
        "y = -(x - 4)^2 + 5",
      ],
      Correct: [1],
      Verse: "",
      List: "",
    },
    // 33
    {
      Question:
        "A horizontal line passes through the point (0, 7)and intersects the parabola at two points. Which of the following is the distance between these two intersection points?",
      Img: ques3335,
      Responses: [
        "2",
        "4",
        "6",
        "8",
      ],
      Correct: [1],
      Verse: "",
      List: "",
    },
    // 34
    {
      Question:
        "The graph shown is a transformation of 𝑦 = 𝑥<sup>2</sup>. Which transformation(s) were applied to obtain the graph?",
      Img: ques3335,
      Responses: [
        "Shift right 2 units and up 3 units",
        "Shift left 2 units and up 3 units",
        "Stretch vertically by a factor of 2 and shift up 3 units",
        "Shift right 2 units and down 3 units",
      ],
      Correct: [0],
      Verse: "",
      List: "",
    },
    // 35
    {
      Question:
        "A line with equation 𝑦 = 𝑘 intersects the parabola at exactly one point. Which value of 𝑘 satisfies this condition?",
      Img: ques3335,
      Responses: [
        "3",
        "5",
        "7",
        "9",
      ],
      Correct: [0],
      Verse: "",
      List: "",
    },
    // 36
    {
      Question:
        "The parabola intersects the horizontal line 𝑦 = 2 at two points. What is the distance between these two points?",
      Img: ques36,
      Responses: [
        "1",
        "2",
        "3",
        "4",
      ],
      Correct: [3],
      Verse: "",
      List: "",
    },
  ];

  const shuffledExams = exams.sort(function () {
    return Math.random() - 0.5;
  });

  const selectedExams = shuffledExams.slice(0, 25);

  dispatch(setExams(selectedExams));
};
